import { CABINET_PAGES } from "./pages-cabinet";
import { EXPERTISES_PAGES } from "./pages-expertises";
import { CLIENTS_PAGES } from "./pages-clients";
import { STANDARDS_PAGES } from "./pages-standards";
import { INVEST_PAGES } from "./pages-invest";
import { MISC_PAGES } from "./pages-misc";

export const ALL_PAGES = [
  ...CABINET_PAGES,
  ...EXPERTISES_PAGES,
  ...CLIENTS_PAGES,
  ...STANDARDS_PAGES,
  ...INVEST_PAGES,
  ...MISC_PAGES,
];
